import { apiClient } from "../../../base/ApiClient";

export const createAssessmentType = async (typeData) => {
  try {
    const response = await apiClient.post('/assessments/assessment-types/', typeData);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error.message;
  }
};

export const fetchInitialAssessmentList = async (clientId) => {
  if (!clientId) {
    throw new Error("Client ID is required.");
  }
  const response = await apiClient.get(`/assessments/init-assessments/?client_id=${clientId}`);
  return response.data;
};

export const fetchAssessmentSchema = async (clientId, typeId) => {
  const response = await apiClient.get(`/assessments/${clientId}/initial-assessments/${typeId}/schema/`);
  return response.data;
};

export const generateAssessmentSchema = async (payload) => {
  const response = await apiClient.post(`/assessments/generate-schema/`, payload);
  return response.data;
};

export const synthesizeAssessment = async (payload) => {
  const response = await apiClient.post(`/assessments/initial-assessment/synthesize/`, payload);
  return response.data;
};

export const updateAssessmentSchema = async (clientId, typeId, schemaData) => {
  const response = await apiClient.patch(`/assessments/update-schema/${typeId}/`, {
    client_id: clientId,
    form_schema: schemaData
  });
  return response.data;
};

export const saveInitialAssessment = async (assessmentData) => {
  const response = await apiClient.post(`/assessments/initial-assessment/save/`, assessmentData);
  return response.data;
};

export const submitAssessmentResponse = async (payload) => {
  try {
    const response = await apiClient.post('/assessments/init-assessment-resp/', payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error.message;
  }
};

export const fetchAssessmentResponses = async (clientID, typeId, page = 1) => {
  try {
    const response = await apiClient.get('/assessments/init-assessment-resp/', {
      params: { 
        client_id: clientID, 
        type_id: typeId,
        page: page,
        page_size: 10
      }
    });
    return response.data; 
  } catch (error) {
    throw error?.response?.data || error.message;
  }
};

export const fetchLatestResponse = async (clientID, typeId) => {
  try {
    const response = await apiClient.get('/assessments/init-assessment-resp/', {
      params: { 
        client_id: clientID, 
        type_id: typeId,
        is_latest: true 
      }
    });
    return Array.isArray(response.data) ? response.data[0] : response.data;
  } catch (error) {
    throw error?.response?.data || error.message;
  }
};

export const fetchResponseDetails = async (responseId) => {
  try {
    const response = await apiClient.get(`/assessments/init-assessment-resp/${responseId}/`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error.message;
  }
};